export type TranslationShape = {
  nav: { aboutUs: string; services: string; projects: string; contact: string; callNow: string };
  footer: { description: string; navigation: string; contact: string; cookiePolicy: string; privacy: string; adminAccess: string; rights: string };
  hero: { seeServices: string; requestQuote: string; heroTitleText: string; heroSubText: string };
  about: { subtitle: string; title: string; titleHighlight: string; p1: string; p2_start: string; p2_bold: string; p2_end: string; p3_start: string; p3_bold: string; p3_end: string; p4_start: string; p4_bold: string; p4_end: string; p5: string; p6: string; videoCaption1: string; videoCaption2: string };
  cta: { title: string; titleHighlight: string; description: string; button: string };
  services: { subtitle: string; title: string; description: string; items: { title: string; description: string; features: string[] }[]; materialsSubtitle: string; materialsTitle: string; outdoorTitle: string; outdoorDesc: string; indoorTitle: string; indoorDesc: string };
  projects: { subtitle: string; title: string; description: string; items: string[]; prevAria: string; nextAria: string; goToAria: string };
  contact: { subtitle: string; title: string; description: string; info: string; address: string; phone: string; email: string; schedule: string; scheduleValue: string; sendFiles: string; sendFilesDesc: string; acceptFormats: string; formTitle: string; name: string; namePlaceholder: string; emailLabel: string; emailPlaceholder: string; phoneLabel: string; phonePlaceholder: string; message: string; messagePlaceholder: string; attachFiles: string; clickToAdd: string; submit: string; submitting: string; successTitle: string; successDesc: string; sendAnother: string; rateLimitError: string; nameError: string; emailError: string; phoneError: string; messageError: string; maxFilesError: string; fileSizeError: string; files: string };
  notFound: { title: string; message: string; backHome: string };
};

export const ro: TranslationShape = {
  // Navbar
  nav: {
    aboutUs: "Despre noi",
    services: "Servicii",
    projects: "Proiectele noastre",
    contact: "Contact",
    callNow: "Sună acum",
  },

  // Footer
  footer: {
    description: "Printuri de mari dimensiuni, publicitate outdoor și soluții vizuale profesionale pentru afacerea ta.",
    navigation: "Navigare",
    contact: "Contact",
    cookiePolicy: "Politica de Cookies",
    privacy: "Confidențialitate",
    adminAccess: "Acces admin",
    rights: "Toate drepturile rezervate.",
  },

  // Index / Hero
  hero: {
    seeServices: "Vezi serviciile",
    requestQuote: "Solicită ofertă",
    heroTitleText: "",
    heroSubText: "",
  },

  // About section
  about: {
    subtitle: "Află cine suntem",
    title: "Euro Nova – Partenerul Tău de Încredere în Producția de Printuri Publicitare de",
    titleHighlight: "Mari Dimensiuni",
    p1: "Euro Nova este o companie românească specializată în execuția printurilor publicitare de mari dimensiuni și în producția de materiale promoționale la calitate foto policromă. Cu ani de experiență în industria tipografică și publicitară, am devenit un partener de referință pentru agenții de publicitate, companii din retail, construcții, imobiliare, auto, evenimente și orice business care pune preț pe impactul vizual al comunicării de brand.",
    p2_start: "Ne diferențiem pe piața producătorilor de print format mare din România prin ",
    p2_bold: "patru piloni esențiali: calitate ridicată, prețuri competitive, viteză de execuție și o echipă serioasă, orientată spre soluții.",
    p2_end: " Indiferent dacă ești o agenție de publicitate cu brief-uri complexe sau o companie care are nevoie de bannere publicitare, mesh-uri, afișe de mari dimensiuni sau materiale de comunicare vizuală pentru punctele de vânzare, la Euro Nova nu există comenzi prea mici sau formate prea mari.",
    p3_start: "Capacitatea de producție ajunge până la ",
    p3_bold: "1.000 mp/zi",
    p3_end: ", susținută de echipamente de ultimă generație care garantează un print publicitar de calitate înaltă și culori fidele, de fiecare dată. Această infrastructură modernă ne permite să onorăm comenzi urgente fără compromisuri în privința calității finale — un avantaj esențial atât pentru agențiile care lucrează în ritm alert, cât și pentru companiile care lansează campanii în termene strânse.",
    p4_start: "Echipa Euro Nova este formată din profesioniști tineri, bine instruiți, cu experiență solidă în producția publicitară și în relația cu clienții. Știm ce înseamnă un deadline scurt și tratăm fiecare proiect cu aceeași seriozitate și atenție la detalii. Mai mult decât execuție, oferim ",
    p4_bold: "consultanță și soluții complete",
    p4_end: ", adaptate specificului fiecărui client.",
    p5: "Portofoliul nostru în continuă creștere și recunoașterea în topul producătorilor de printuri de mari dimensiuni din România sunt dovada standardelor după care lucrăm zilnic.",
    p6: "Calitate. Viteză. Prețuri corecte. Alege Euro Nova — producătorul de print publicitar care se ridică la nivelul așteptărilor tale.",
    videoCaption1: "Printuri mari - clienți mari! ",
    videoCaption2: "Printare de mari dimensiuni la calitate foto — unul din echipamentele noastre în funcțiune.",
  },

  // CTA section
  cta: {
    title: "Ai un proiect",
    titleHighlight: "în minte",
    description: "Contactează-ne pentru o ofertă personalizată. Livrăm rapid, la cele mai bune prețuri.",
    button: "Solicită ofertă",
  },

  // Services page
  services: {
    subtitle: "Servicii",
    title: "Serviciile noastre",
    description: "Oferim o gamă completă de servicii de printare de mari dimensiuni, de la concept la produs finit.",
    items: [
      {
        title: "Bannere & Mesh",
        description: "Printare pe banner PVC și mesh de mari dimensiuni, ideale pentru publicitate outdoor, evenimente, construcții și festivaluri. Rezistente la UV și intemperii, cu culori vibrante și durabile.",
        features: ["Lățime până la 3.2m", "Rezistență UV", "Confecționare ochiuri"],
      },
      {
        title: "Autocolante & Folii",
        description: "Autocolante PVC, folii cast și polimerice pentru casetare auto, decorarea vitrinelor, tapete personalizate și aplicații indoor/outdoor de lungă durată.",
        features: ["Folii auto", "Folii vitrine", "Laminare protecție"],
      },
      {
        title: "Postere & Canvas",
        description: "Printare fotografică de înaltă rezoluție pe hârtie premium, canvas artist și hârtie backlit pentru casetele luminoase. Culori fidele și detalii excepționale.",
        features: ["Rezoluție 1440dpi", "Hârtie premium", "Canvas cu rame"],
      },
      {
        title: "Etichete & Print Digital/Offset",
        description: "Etichete policromie din PVC rezistente la apă și UV, drepte sau cu forme speciale. Print digital și offset (cărți de vizită, flyere, cataloage), afișe în serie mică/unicat sau tiraje mari.",
        features: ["Etichete PVC", "Print offset", "Tiraje mari"],
      },
      {
        title: "Signalistică",
        description: "Litere volumetrice iluminate și neiluminate, casete luminoase, panouri publicitare, totemuri și sisteme de semnalizare interioară și exterioară.",
        features: ["Litere volumetrice", "Casete luminoase", "Totemuri"],
      },
      {
        title: "Design Grafic",
        description: "Servicii complete de design grafic: adaptare fișiere pentru print, creare machete publicitare, brandbook, identitate vizuală și pregătire fișiere.",
        features: ["Machete print", "Identitate vizuală", "Pregătire fișiere"],
      },
    ],
    materialsSubtitle: "Materiale",
    materialsTitle: "Pe ce printăm",
    outdoorTitle: "Materiale Outdoor",
    outdoorDesc: "Poliplan (simplă și dublă față), mesh, poliplan backlite (casetă luminoasă), autocolant PVC (panouri, vitrine exterioare, înscripționat mașini), window grafic (material one-way vision pentru vitrine magazin), steaguri pentru catarg / beach flag",
    indoorTitle: "Materiale Indoor",
    indoorDesc: "Hârtie photo – postere, autocolant PVC, canvas, polipropilenă – RollUp, backlite film, pânză display (popUP, masă sampling)",
  },

  // Projects page
  projects: {
    subtitle: "Portofoliu",
    title: "Proiectele noastre",
    description: "Descoperă o selecție din lucrările realizate de echipa Euro Nova.",
    items: [
      "Amenajare fațadă de magazin",
      "Casetă luminoasă, dublă față, expunere interioară",
      "Bannere de mari dimensiuni",
      "Etichete PVC cu forme speciale",
      "Tablouri canvas - amenajări interioare",
      "Inscripționări auto",
      "Mesh - acoperiri fațade clădiri",
      "Tapet textil - o singură imagine, fără tile-uri",
      "Print prelată de camion",
      "Amenajare stand expozițional",
    ],
    prevAria: "Proiectul anterior",
    nextAria: "Proiectul următor",
    goToAria: "Mergi la proiectul",
  },

  // Contact page
  contact: {
    subtitle: "Contact",
    title: "Contactează-ne",
    description: "Solicită o ofertă sau pune-ne orice întrebare despre serviciile noastre de printare.",
    info: "Informații",
    address: "Adresă",
    phone: "Telefon",
    email: "Email",
    schedule: "Program cu clienții",
    scheduleValue: "Luni – Vineri: 09:00 – 16:00",
    sendFiles: "Trimite fișierele",
    sendFilesDesc: "Poți trimite fișierele pentru print la",
    acceptFormats: ". Acceptăm formate: PDF, AI, EPS, TIFF, PSD, JPG (min. 150 DPI).",
    formTitle: "Solicită ofertă",
    name: "Nume",
    namePlaceholder: "Numele dumneavoastră",
    emailLabel: "Email",
    emailPlaceholder: "email@exemplu.ro",
    phoneLabel: "Telefon",
    phonePlaceholder: "07xx xxx xxx",
    message: "Mesaj / Detalii proiect",
    messagePlaceholder: "Descrie proiectul: dimensiuni, material, cantitate...",
    attachFiles: "Atașează fișiere",
    clickToAdd: "Click pentru a adăuga fișiere",
    submit: "Trimite cererea",
    submitting: "Se trimite...",
    successTitle: "Cererea a fost trimisă!",
    successDesc: "Vă vom contacta în cel mai scurt timp.",
    sendAnother: "Trimite altă cerere",
    rateLimitError: "Ați trimis prea multe cereri. Vă rugăm să încercați din nou mai târziu.",
    nameError: "Numele trebuie să aibă între 2 și 100 de caractere.",
    emailError: "Adresa de email nu este validă.",
    phoneError: "Numărul de telefon nu este valid.",
    messageError: "Mesajul trebuie să aibă între 10 și 2000 de caractere.",
    maxFilesError: "Puteți atașa maximum",
    fileSizeError: "depășește limita de 20MB.",
    files: "fișiere",
  },

  // 404
  notFound: {
    title: "404",
    message: "Oops! Pagina nu a fost găsită",
    backHome: "Înapoi la pagina principală",
  },
};
